import React from 'react';
import {Form} from 'semantic-ui-react';
import _ from 'lodash';
import {displayError, calculateLineItemPaymentTotals} from 'common/requestDetails/utils';
import SimpleShared from 'go/components/modules/requestDetails/v3/items/shared/SimpleShared';
import {
  ADDITIONAL_INFORMATION,
  CARD_TYPES,
  COMMENTS,
  COST,
  DESCRIPTION,
  FIELD_MAX_LENGTHS_SYSTEM,
  PAYMENT,
  PAYMENT_PATH_ROOT,
  PRICE,
  QUANTITY,
} from 'common/requestDetails/constants';
import DynamicElement from '../shared/DynamicElement';
import {safeMult} from 'common/utils';
import {ExpandingTextArea} from '../shared';
export default class Simple extends React.Component {
  state = {
    lineItem: this.props.item,
  };

  componentDidMount() {
    let {item} = this.props;
    let updatedItem = this.refreshTotals(item);
    this.handleChange(updatedItem).then((res) => this.handleBlur());
  }

  handleChange = (lineItem) => {
    return new Promise((resolve) => {
      this.setState({lineItem}, () => resolve());
    });
  };

  handleBlur = (fieldName) => {
    if (this.props.editable) {
      let {lineItem} = this.state;
      let {item} = this.props;
      lineItem = _.cloneDeep(lineItem);
      let itemToDisplay = {
        ...lineItem,
        [ADDITIONAL_INFORMATION]: {
          ..._.get(item, ADDITIONAL_INFORMATION), // need to bring in additional information saved outside this component
          ..._.get(lineItem, ADDITIONAL_INFORMATION),
        },
      };

      this.setState((prevState) => ({
        lineItem: {
          ...prevState.lineItem,
          bocTotals: itemToDisplay.bocTotals,
        },
      }));
      this.props.saveItem(this.props.sourcePath, itemToDisplay, fieldName);
    }
  };

  handleItemChange = (name, value, ind = -1, extraArgs) => {
    const {item} = this.props;
    let newLineItem = _.cloneDeep(item);
    _.set(newLineItem, name, value);
    if(_.get(extraArgs, "resetFields")){
      _.each(extraArgs.resetFields, field => {
        _.unset(newLineItem, field)
      })
  }
    return this.handleChange(this.refreshTotals(newLineItem));
  };

  handleItemChangeAndBlur = (name, value, fieldName) => {
    this.handleItemChange(name, value).then((res) => {
      this.handleBlur(fieldName);
    });
  };

  refreshTotals = (item) => {
    let payments = _.cloneDeep(_.get(item, PAYMENT_PATH_ROOT));
    let updatedItem = item;
    if (payments) {
      _.forEach(payments, (payment) => {
        if (payment.quantity && payment.price) {
          if (_.get(payment, 'total') !== safeMult(payment.quantity, payment.price)) {
            payment.total = safeMult(payment.quantity, payment.price);
          }
        } else {
          payment.total = 0;
        }
      });
      if (!_.isEqual(payments, _.get(item, PAYMENT_PATH_ROOT))) {
        updatedItem = {
          ...item,
          additionalInformation: item.additionalInformation
            ? {
                ...item.additionalInformation,
                payment: payments,
              }
            : {},
        };
      }
    }
    return updatedItem;
  };

  renderComments(index = 0) {
    const {
      id,
      editable,
      validationErrors,
      validationDirtyMap,
      validationDirtyPage,
    } = this.props;

    const {lineItem} = this.state;

    const commentsPath = `${ADDITIONAL_INFORMATION}.${PAYMENT}.${index}.${COMMENTS}`;
    const comments = _.get(lineItem, commentsPath);
    const commentsLabel = 'Comments';

    const commentsErrors = displayError(
      COMMENTS,
      commentsPath,
      validationErrors,
      validationDirtyMap,
      validationDirtyPage
    );

    const FIELD_LENGTHS = _.get(FIELD_MAX_LENGTHS_SYSTEM, CARD_TYPES.SIMPLE);
    const DESCRIPTION_MAX = _.get(FIELD_LENGTHS, DESCRIPTION);

    return (
      <React.Fragment>
        <ExpandingTextArea
          id={id}
          fieldName={COMMENTS}
          expanded={editable}
          value={comments}
          label={commentsLabel}
          closedLabel={commentsLabel}
          handleChange={(value) => this.handleItemChange(commentsPath, value)}
          maxLength={DESCRIPTION_MAX}
          handleBlur={() => this.handleBlur(commentsPath)}
          errorMessages={commentsErrors.errorMessages}
          displayError={commentsErrors.displayError}
        />
      </React.Fragment>
    );
  }

  renderPaymentRequestedSection = () => {
    const {itemConfig, displayFields, editable} = this.props;
    const {lineItem} = this.state;
    const hasPayment =
      _.get(lineItem, [...PAYMENT_PATH_ROOT, 0, QUANTITY]) *
        _.get(lineItem, [...PAYMENT_PATH_ROOT, 0, PRICE]) >
      0;
    const groupByRows = _.chain(
        _.get(itemConfig, 'itemCardContents.detailSection.paymentRequestGrid')
      )
      .groupBy('rowOrder')
      .map((value, key) => value)
      .value();
    return (
      <div className="payment-requested-section">
        <h5>Payment requested</h5>
        <Form>
          {_.map(groupByRows, (data, rowIndex) => {
            let key = 0 + '_' + rowIndex;
            return (
              <div
                key={this.props.id + '_div_' + key}
                className="app-form-row margin-bottom-25"
              >
                {_.map(data, (conf) => {
                  return (
                    <DynamicElement
                      key={this.props.id + '_dyn_' + key}
                      id={this.props.id}
                      conf={conf}
                      index={0}
                      cost={lineItem}
                      handleBlur={this.handleBlur}
                      handleItemChange={this.handleItemChange}
                      validationErrors={this.props.validationErrors}
                      validationDirtyMap={this.props.validationDirtyMap}
                      editable={editable}
                    />
                  );
                })}
              </div>
            );
          })}
          {_.includes(displayFields, 'comments') &&
            hasPayment &&
            this.renderComments(0)}
        </Form>
      </div>
    );
  };

  render() {
    const {beingCreated, sourcePath} = this.props;
    const {lineItem} = this.state;
    const hasPayment =
      _.get(lineItem, [...PAYMENT_PATH_ROOT, 0, QUANTITY]) *
        _.get(lineItem, [...PAYMENT_PATH_ROOT, 0, PRICE]) >
      0;
    const isNewlyCreated = !!_.find(
      _.get(lineItem, 'additionalInformation.changes', []),
      (change) => change.type === 'newlyCreated'
    );
    const pastTotalPayment = calculateLineItemPaymentTotals(
      _.get(this.context, 'otherPayments', []),
      sourcePath
    );
    return (
      <SimpleShared
        lineItem={lineItem}
        handleChange={this.handleChange}
        handleBlur={this.handleBlur}
        handleItemChange={this.handleItemChange}
        handleItemChangeAndBlur={this.handleItemChangeAndBlur}
        renderChangesSection={this.renderPaymentRequestedSection}
        changesSectionClassName={
          (isNewlyCreated || hasPayment) && !beingCreated ? 'background--info' : ''
        }
        pastTotalPayment={pastTotalPayment}
        {...this.props}
      />
    );
  }
}
